import { createComponent } from 'react-fela'

const Icon = props => ({
  width: props.width || props.size,
  height: props.height || props.size,
  backgroundImage: `url(${props.icon})`,
  backgroundSize: '100% 100%',
  marginTop: props.offset,
  cursor: props.cursorType || 'default'
})

export default createComponent(Icon, 'div', ['onClick'])



// WEBPACK FOOTER //
// ../components/Icon.js